import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../utils/secure-route/AuthContext";

const SocialAuthCallback = () => {
  const navigate = useNavigate();
  const { setManualAuthToken } = useContext(AuthContext);
  const [message, setMessage] = useState("Signing you in...");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const queryParams = new URLSearchParams(window.location.search);
    const access = hashParams.get("access");
    const refresh = hashParams.get("refresh");
    const error = queryParams.get("error");

    if (error) {
      setFailed(true);
      setMessage(error);
      return;
    }

    if (!access || !refresh) {
      setFailed(true);
      setMessage("Social login did not return a valid session.");
      return;
    }

    setManualAuthToken({ access, refresh });
    navigate("/", { replace: true });
  }, [navigate, setManualAuthToken]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={failed ? styles.errorIcon : styles.icon}>{failed ? "!" : "✓"}</div>
        <h1 style={styles.title}>{failed ? "Login could not be completed" : "Almost there"}</h1>
        <p style={styles.text}>{message}</p>
        {failed && (
          <Link style={styles.button} to="/login">
            Back to login
          </Link>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: "24px",
    background: "#eef3ff",
  },
  card: {
    width: "min(480px, 100%)",
    padding: "36px",
    borderRadius: "24px",
    background: "#fff",
    border: "1px solid #e2e8f0",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.14)",
    textAlign: "center",
  },
  icon: {
    width: "58px",
    height: "58px",
    margin: "0 auto 18px",
    borderRadius: "18px",
    display: "grid",
    placeItems: "center",
    background: "#dcfce7",
    color: "#15803d",
    fontSize: "28px",
    fontWeight: 900,
  },
  errorIcon: {
    width: "58px",
    height: "58px",
    margin: "0 auto 18px",
    borderRadius: "18px",
    display: "grid",
    placeItems: "center",
    background: "#fee2e2",
    color: "#dc2626",
    fontSize: "28px",
    fontWeight: 900,
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "28px",
    fontWeight: 950,
  },
  text: {
    margin: "10px 0 0",
    color: "#64748b",
    fontSize: "15px",
    fontWeight: 750,
  },
  button: {
    display: "inline-flex",
    marginTop: "22px",
    padding: "13px 20px",
    borderRadius: "12px",
    background: "#0d532f",
    color: "#fff",
    fontWeight: 900,
    textDecoration: "none",
  },
};

export default SocialAuthCallback;
